import React, { useRef } from "react";
import "date-fns";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import DateFnsUtils from "@date-io/date-fns";
import EditIconRounded from "@material-ui/icons/EditRounded";
import DeleteOtlined from "@material-ui/icons/DeleteRounded";
import { useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContex";
import { CircularProgress } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ModaluseStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 180,
  },
  formControlLabel: {
    marginTop: theme.spacing(1),
  },
}));

const useBtnStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

export default function MinhaOrdens() {
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const { user } = useContext(AuthContext);

  const [tableinformation, settableinformation] = useState([]);
  const [tableRows, settableRows] = useState([]);
  const [ordems, setOrdens] = useState([]);
  const [savingOrdem, setSavingordem] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [dialogMessage, setdialogMessage] = useState({
    message: "Guardado Com Successo",
    style: "success",
  });

  const [condicaoPreco, setCondicaoPreco] = React.useState("");
  const [condicaoTempora, setcondicaoTempora] = React.useState("");
  const handlecondicaoPreco = (event) => {
    setCondicaoPreco(event.target.value);
  };
  const handlecondicaoTemporal = (event) => {
    setcondicaoTempora(event.target.value);
  };

  const classButton = useBtnStyles();

  const modelClass = ModaluseStyles();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (row) => {
    settableinformation(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseSuccess = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSuccess(false);
  };

  const eliminarOrdens = async (id) => {
    setOrdens([]);
    setdialogMessage({ message: "Eliminado com Successo", style: "warning" });
    setSavingordem(true);
    try {
      const res = await axios.delete("ordem/" + id);
      setOrdens(res.data);
      setSavingordem(false);
      setOpen(false);
      setOpenSuccess(true);
    } catch (err) {
      console.log(err);
    }
  };

  const quantidade_total = useRef();
  const quantidade_minima = useRef();
  const preco_limite = useRef();
  const preco_disparo = useRef();
  const codigo_de_negociacao = useRef();
  const condicao_temporal = useRef();
  const userentrydatechosen = useRef();
  const condicao_preco = useRef();

  const guadarOrdens = async (id) => {
    setdialogMessage({ message: "Guardado Com Successo", style: "success" });

    setSavingordem(true);
    const ordems = {
      quantidade_total: quantidade_total.current.value,
      preco_limite: preco_limite.current.value,
      preco_disparo: preco_disparo.current.value,
      codigo_de_negociacao: codigo_de_negociacao.current.value,
    };

    try {
      const res = await axios.put("ordem/" + id, ordems);
      setOrdens(ordems);
      setSavingordem(false);
      setOpen(false);
      setOpenSuccess(true);
    } catch (err) {
      console.log(err);
    }
  };

  const [selectedDate, setSelectedDate] = React.useState(
    new Date("2014-08-10T21:11:54")
  );

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  useEffect(() => {
    const buscarOrdens = async () => {
      try {
        const res = await axios.get("ordem/usuario/" + user._id);
        settableRows(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    buscarOrdens();
  });

  return (
    <>
      <table className="table table-hover  table-sm text-white">
        <thead>
          <tr>
            <th>Código</th>
            <th>Qty</th>
            <th>Stop Loss</th>
            <th>Take Gain</th>
            <th>Estado</th>
            <th>Alterar</th>
            <th>Eliminar</th>
          </tr>
        </thead>
        <tbody>
          {tableRows.map((row) => (
            <tr key={row._id} style={{ color: "white" }}>
              <td scope="row">{row.codigo_de_negociacao}</td>
              <td>{row.quantidade_total}</td>
              <td>{row.preco_disparo}</td>
              <td>{row.preco_limite}</td>
              <td>Pendente</td>
              <td>
                <button
                  onClick={() => handleClickOpen(row)}
                  className="btn btn-outline-info btn-rounded"
                >
                  <i className="uil-edit"></i>
                </button>
              </td>

              <td>
                <button
                  onClick={() => eliminarOrdens(row._id)}
                  className="btn btn-outline-danger btn-rounded"
                >
                  <i className="uil-trash"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Snackbar
        open={openSuccess}
        autoHideDuration={2300}
        onClose={handleCloseSuccess}
      >
        <Alert onClose={handleCloseSuccess} severity={dialogMessage.style}>
          {dialogMessage.message}
        </Alert>
      </Snackbar>

      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogTitle id="max-width-dialog-title">Actualizar Oferta</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Actualização da Janela de Ofertas
          </DialogContentText>
          <form className={modelClass.form} noValidate>
            <Grid container spacing={1} style={{ marginTop: "10px" }}>
              <Grid item xs={3}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Codigo de negociacao "
                    defaultValue={tableinformation.codigo_de_negociacao}
                    variant="filled"
                    inputRef={codigo_de_negociacao}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={3}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Quantidade"
                    defaultValue={tableinformation.quantidade_total}
                    type="number"
                    inputRef={quantidade_total}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={3}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Stop Loss"
                    defaultValue={tableinformation.preco_limite}
                    inputRef={preco_limite}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Take Gain"
                    defaultValue={tableinformation.preco_disparo}
                    inputRef={preco_disparo}
                    type="number"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4} style={{ marginTop: "20px" }}></Grid>
              <Grid item xs={2} style={{ marginTop: "20px" }}>
                <Button
                  variant="contained"
                  onClick={() => guadarOrdens(tableinformation._id)}
                  color="primary"
                  disabled={savingOrdem}
                >
                  {!savingOrdem ? (
                    "Guardar"
                  ) : (
                    <CircularProgress color="green" size="22px" />
                  )}
                </Button>
              </Grid>

              <Grid item xs={2} style={{ marginTop: "20px" }}>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={savingOrdem}
                  onClick={() => eliminarOrdens(tableinformation._id)}
                >
                  {!savingOrdem ? (
                    "Eliminar"
                  ) : (
                    <CircularProgress color="green" size="22px" />
                  )}
                </Button>
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
